module.exports = __webpack_public_path__ + "static/project-ares-logo-white-87c84a6be6010689152b749fb9c94d56.svg";